export const INSTAGRAM_USERNAME_URL = "https://instagram.com/";
export const TIKTOK_USERNAME_URL = "https://tiktok.com/@";
export const YOUTUBE_USERNAME_URL = "https://youtube.com/@";
export const TWITCH_USERNAME_URL = "https://www.twitch.tv/";
